import { render, staticRenderFns } from "./CommodityAnalysis.vue?vue&type=template&id=2ca4cfb6&scoped=true"
import script from "./CommodityAnalysis.vue?vue&type=script&lang=js"
export * from "./CommodityAnalysis.vue?vue&type=script&lang=js"
import style0 from "./CommodityAnalysis.vue?vue&type=style&index=0&id=2ca4cfb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca4cfb6",
  null
  
)

export default component.exports